// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3pKPu","calendarButtons":"ClockData_calendarButtons__2OUxY"};